import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0D12] px-4">
      <div className="w-full max-w-md bg-[#181F2C] border border-[#263147] rounded-3xl p-8 shadow-2xl animate-fade-up">
        {sent ? (
          <div className="text-center space-y-4">
            <div className="w-14 h-14 rounded-2xl bg-emerald-500/15 flex items-center justify-center mx-auto">
              <MailCheck className="w-7 h-7 text-emerald-400" />
            </div>
            <h1 className="text-xl font-bold font-heading text-slate-100">Verifique seu e-mail</h1>
            <p className="text-sm text-slate-400">
              Se esse e-mail estiver cadastrado, enviamos um link para redefinir sua senha.
            </p>
            <Link to="/login" className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm">
              <ArrowLeft className="w-4 h-4" /> Voltar ao login
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-xl font-bold font-heading text-slate-100 mb-1">Redefinir senha</h1>
            <p className="text-sm text-slate-400 mb-6">Informe seu e-mail para receber o link.</p>
            <form onSubmit={submit} className="space-y-5">
              <div className="space-y-2">
                <Label htmlFor="fp-email" className="text-slate-300">E-mail</Label>
                <Input
                  id="fp-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-12 bg-[#0F1520] border-[#263147] text-slate-100 rounded-xl focus-visible:ring-emerald-500"
                />
              </div>
              {error && <div className="text-sm text-red-400">{error}</div>}
              <Button type="submit" disabled={loading} className="w-full h-12 bg-emerald-500 hover:bg-emerald-600 text-[#0A0D12] font-semibold rounded-xl">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Enviar link"}
              </Button>
              <Link to="/login" className="flex items-center justify-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm">
                <ArrowLeft className="w-4 h-4" /> Voltar ao login
              </Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
